<template>
  <edit></edit>
</template>
<script>
	import edit from './newsinfo_edit.vue'
	
	export default {
		name: 'm_newsinfo_add',
		
		// props: {
		// 	classify: String
		// },
		
		components: {
			edit
		}
	}
</script>